<template>
  <v-img :src="imageUrl" :width="width" :height="height" class="game-logo"></v-img>
</template>

<script>
export default {
  name: 'GameLogo',
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style scoped>
.game-logo {
  border-radius: 23px;
  overflow: hidden;
}
</style>
